var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-inner"},[_c('div',{staticClass:"list-item-inner__data-row",attrs:{"title":_vm.source.message}},[_vm._v(" "+_vm._s(_vm.source.resume || "—")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }